/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * dataSources：数据源
 */

let baseUrl = '';
let routerMode = 'hash';
let dataSources = 'local'; //local=本地，其他值代表非本地
let wxappid='wx9b336b45efb4297a';
//正式 wx9b336b45efb4297a
if (process.env.NODE_ENV == 'development') {
	baseUrl = 'http://localhost:29001/';
} else if (process.env.NODE_ENV == 'production') {
	baseUrl = 'http://tymc.ypunai.com/';
}

export {
	baseUrl,
	routerMode,
	dataSources,
	wxappid
}